import React from "react";

import { useTranslation } from "react-i18next";

import ModeratorList from "./ModeratorList";
import SwitchOnOff from "../../common/tools/SwitchOnOff";

import type { JSX } from "react";

import type { StorefrontProjectParams } from "../../../api/ProjectAPI.types";

interface LiveChatConfigurationProps {
  hasAllowChatLive: boolean;
  hasAllowLiveOkast: boolean;
  hasLivechatDisplayUserCount: boolean;
  onChange: <K extends keyof StorefrontProjectParams>(
    key: K,
    value: StorefrontProjectParams[K],
  ) => void;
}

function LiveChatConfiguration({
  hasAllowChatLive,
  hasAllowLiveOkast,
  hasLivechatDisplayUserCount,
  onChange,
}: LiveChatConfigurationProps): JSX.Element | null {
  const { t } = useTranslation("editor-platform");

  if (!hasAllowLiveOkast) return null;

  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">{t("liveChatSettings")}</div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            checked={hasAllowChatLive ?? false}
            iconName=""
            name="allow_livechat"
            size="sm"
            onChange={(value: boolean): void => {
              onChange("allow_chat_live", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("enableLiveChat")}</div>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            checked={hasLivechatDisplayUserCount ?? false}
            iconName=""
            name="livechat_display_user_count"
            size="sm"
            onChange={(value: boolean): void => {
              onChange("livechat_display_user_count", value);
            }}
          />
          <div className="editor-form-label">
            {t("livechatDisplayUserCount")}
          </div>
        </div>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>{t("moderatorList")}</label>
      </div>
      <div className="editor-form-input">
        <ModeratorList />
      </div>
    </div>
  );
}

export default LiveChatConfiguration;
